import { render, staticRenderFns } from "./PersonProfileRecentHistoryOverviewRow.vue?vue&type=template&id=21ece017&scoped=true&"
import script from "./PersonProfileRecentHistoryOverviewRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileRecentHistoryOverviewRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ece017",
  null
  
)

export default component.exports